module.exports = __webpack_public_path__ + "static/img/s-vivo-3.5b9e3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-vivo-3.png
// module id = r3zt
// module chunks = 1